// extracted by mini-css-extract-plugin
module.exports = {"featureWrapper":"PackageFeatures_featureWrapper__160QC","iconWrapper":"PackageFeatures_iconWrapper__2opgQ"};